import * as d3 from 'd3'
import moment from 'moment'
export default {
  methods: {
    
    draw_Header() {

      let ganttHeader = this.canvasGantt
      .append('g')
      .attr('transform', `translate(${this.header.x}, ${this.header.y})`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      let cutoff = moment(moment(this.timeline.cutoff).format('YYYY-MM-DD 23:59:59')).toDate()

      ganttHeader
      .append('rect')
      .attr('x', this.header.width).attr('y', 2).attr('width', this.timeline.scale(cutoff))
      .attr('height', this.header.height)
      .attr('fill', `url(#${this.localId}_LightBlue_)`).attr('opacity', .3)


      this.header.columns.forEach(d=> {

        ganttHeader
        .append('text')
        .attr('x', d.mx).attr('y', 25)
        .attr('font-size', 11).attr('fill', '#333')
        .attr('text-anchor', 'middle')
        .text(d.name)

        ganttHeader
        .append('line')
        .attr('x1', d.ex).attr('y1', 10)
        .attr('x2', d.ex).attr('y2', this.header.height-7)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
      })

    },

    getNextDate(dateStr) {
      const [year, month, day] = dateStr.split('-').map(Number);

      const date = new Date(year, month - 1, day);
      date.setDate(date.getDate() + 1);

      return date.getFullYear() + '-' +
             String(date.getMonth() + 1).padStart(2, '0') + '-' +
             String(date.getDate()).padStart(2, '0');
    }

  }
}
